export const CASH = 'CASH';
export const VISA_ONLINE = 'VISA_NET';
export const OCA = 'OCA';
export const TICKET = 'TICKET';

export default {
  CASH,
  VISA_ONLINE,
  OCA,
  TICKET,
};
